import type React from 'react';

import { GENDER_OPTIONS } from '@vlabs/api-bindings/src/constants';
import { GenderFemaleIcon, GenderMaleIcon, GenderUnknownIcon } from '@vlabs/icons';
import type { WithDataTestid, WithClassNameProp } from '@vlabs/uikit/types';
import { useTranslation } from 'react-i18next';

import { AttributeCard } from './attribute-card/AttributeCard';

const GENDER_ICONS = {
  0: <GenderFemaleIcon />,
  1: <GenderMaleIcon />,
  null: <GenderUnknownIcon />,
};

interface GenderAttributeCardProps extends WithDataTestid, WithClassNameProp {
  gender: 0 | 1 | 2 | null;
}

export function GenderAttributeCard({
  gender,
  className = undefined,
  'data-testid': dataTestId = 'GenderAttributeCard',
  ...props
}: GenderAttributeCardProps): React.JSX.Element {
  const { t } = useTranslation();

  const normalizedGender = gender === 2 ? null : gender;

  const description = GENDER_OPTIONS[normalizedGender]?.label;
  const icon = GENDER_ICONS[normalizedGender];

  return (
    <AttributeCard
      className={className}
      data={normalizedGender}
      data-testid={dataTestId}
      description={description}
      icon={icon}
      title={t('shared:attribute_cards.gender.title')}
      {...props}
    />
  );
}
